import PropTypes from "prop-types";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import ReactDOMServer from "react-dom/server";
import ClusterizeJS from "clusterize.js";
import { browserHistory } from "react-router";

class Clusterize extends Component {
  static propTypes = {
    rows: PropTypes.array,
    isSuite: PropTypes.bool,
    selectAll: PropTypes.bool,
    handleSelectAll: PropTypes.func,
    scrollTop: PropTypes.number,
    onCheckboxChange: PropTypes.func.isRequired,
    onRowClick: PropTypes.func,
    createTableHeader: PropTypes.node,
  };
  
  static defaultProps = {
    rows: [],
    isSuite: false,
    selectAll: false,
    handleSelectAll: () => {},
    scrollTop: 0,
  };

  clusterize = null;
  scrollElem = null;
  contentElem = null;

  componentDidMount() {
    this.initializeClusterize();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.rows !== this.props.rows) {
      this.updateClusterize();
    }
    if (prevProps.scrollTop !== this.props.scrollTop) {
      this.scrollElem.scrollTop = this.props.scrollTop;
    }
  }

  componentWillUnmount() {
    if (this.clusterize) {
      this.clusterize.destroy(true);
      this.clusterize = null;
    }
  }

  initializeClusterize() {
    const scrollElem = ReactDOM.findDOMNode(this.scrollElem);
    const contentElem = ReactDOM.findDOMNode(this.contentElem);

    const rows = this.props.rows.map(row => {
      if (typeof row === "string") {
        return row;
      }
      return React.isValidElement(row)
        ? ReactDOMServer.renderToString(row)
        : null;
    });

    this.clusterize = new ClusterizeJS({
      rows,
      scrollElem,
      contentElem,
      tag: "tr",
      show_no_data_row: false
    });

    this.attachEventListeners();
  }

  updateClusterize() {
    if (this.clusterize) {
      const rows = this.props.rows.map(row => {
        if (typeof row === "string") {
          return row;
        }
        return React.isValidElement(row)
          ? ReactDOMServer.renderToString(row)
          : null;
      });
      this.clusterize.update(rows);
      this.attachEventListeners();
    }
  }

  attachEventListeners() {
    const contentArea = document.getElementById("contentArea");
    if (contentArea) {
      // Les listeners sont des méthodes-classe stables (mêmes références à chaque
      // init/update) : addEventListener ignore les doublons identiques, donc pas d'empilement.
      contentArea.addEventListener('change', this.handleCheckboxChange);
      contentArea.addEventListener('click', this.handleRowClick);
    }
  }

  handleCheckboxChange = (event) => {
    if (event.target.type === 'checkbox') {
      const id = event.target.getAttribute('data-id');
      this.props.onCheckboxChange(id);
    }
  }

  // Les lignes sont du HTML statique (ReactDOMServer.renderToString) : les onClick React
  // sont supprimés. On délègue donc le clic sur toute la ligne au niveau du <tbody>.
  handleRowClick = (event) => {
    if (!this.props.onRowClick) return;
    // Laisser le comportement natif pour les clics modifiés (ouvrir dans un nouvel onglet, etc.).
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
    // La case à cocher gère sa propre sélection (event 'change') — ne pas naviguer/restaurer.
    if (event.target.closest('.check-box-cell')) return;
    const row = event.target.closest('tr');
    if (!row) return;
    const restoreId = row.getAttribute('data-restore-id');
    const url = row.getAttribute('data-url');
    if (restoreId) {
      event.preventDefault();
      this.props.onRowClick({ type: 'restore', id: restoreId });
    } else if (url) {
      // Empêche la double-navigation via l'ancre <a href> native.
      event.preventDefault();
      this.props.onRowClick({ type: 'navigate', url });
    }
  }

  renderHeader() {
    const { createTableHeader } = this.props;
    if (createTableHeader) {
      return (
        <thead className="table-header" role="rowgroup">
          {/* Sélection ouverte à tous les comptes : seules certaines actions restent réservées
              (cf. "Modifier", limité aux comptes L+ Suite). */}
          <tr id="header_label" className="flex-row check-box-header">
            <th>
              <input
                type="checkbox"
                checked={this.props.selectAll}
                onChange={this.props.handleSelectAll}
              />
            </th>
          </tr>
          {createTableHeader}
        </thead>
      )
    }
  }

  render() {
    const { className, style } = this.props;

    return (
      <div
        ref={node => {
          this.scrollElem = node;
        }}
        className={className}
        style={{
          height: "100%",
          overflow: "auto",
          ...style,
        }}
      >
        <div className="clusterize">
          <div id="scrollArea" className="clusterize-scroll">
            <table id="account-table" role="table">
              {this.renderHeader()}
              <tbody
                id="contentArea"
                className="clusterize-content"
                ref={node => {
                  this.contentElem = node;
                }}
              ></tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }  
}

export default Clusterize;
